import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="prompt" id="prompt"></a>
    <h1 {...{
      "id": "windowprompt"
    }}>{`window.prompt()`}</h1>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - message entered by the user in the prompt field or default value if nothing entered.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0`}</p>
    <br></br>
    <p>{`Displays a Prompt message dialog putting the application in a modal state while `}<b>{`not blocking`}</b>{` the Javascript thread and still allowing processing of events in the main event loop.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`UXP behaviour is different from the standard behaviour of blocking the javascript thread of execution until the dialog has been dismissed.`}</p>
    <p>{`The following are additional simple alerts supported by UXP`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "./confirm.md"
        }}>{`confirm()`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "./alert.md"
        }}>{`alert()`}</a>{`  `}</li>
    </ol>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string of text to display to the user.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`prompt`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default value for the field.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Below prompt function has 2 params
// "Enter your name: " - Message to display
// "Adobe" - Default value that will be present in the Prompt pop-up at launch
prompt("Enter your name: ","Adobe");
`}</code></pre>
    <b> Note: </b>
1. Since UXP v7.4, `prompt()` can only be invoked in `plugin` via the featureFlags `enableAlerts`. Update your Manifest v5 with the following
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"featureFlags": {
     "enableAlerts": true
 }
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Since UXP v7.4, `}<inlineCode parentName="li">{`prompt()`}</inlineCode>{` is disabled for `}<inlineCode parentName="li">{`scripts`}</inlineCode></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      